import React from 'react';

const Order = () => {
  return (<div>
      orders
  </div>);
};

export default Order;
